export default "__VITE_ASSET__d25831a2__"